import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Kpi, KpiCategories, KpiKeys, KpisByKey, MilestoneName } from '@models';

@Component({
  selector: 'kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss'
})
export class KpiCardComponent {
  @Input() category!: KpiCategories;
  @Input() kpis!: KpisByKey;
  @Input() tooltipsEnabled = true;
  @Input() selectedKpiKey?: KpiKeys;
  @Input() keyMilestones?: MilestoneName[];
  @Output() kpiCardClicked = new EventEmitter<KpiKeys>();

  handleKpiSelection(kpiKey: KpiKeys): void {
    this.kpiCardClicked.emit(kpiKey);
  }

  getKpiKey(stringKey: string): KpiKeys {
    return stringKey as KpiKeys;
  }

  sortKpisByName = (a: { key: string; value: Kpi }, b: { key: string; value: Kpi }): number => {
    return a.value.name.localeCompare(b.value.name);
  };
}
